module.exports = new __parcel__URL__("10Calc.ee714047.webp").toString();